import axios from "axios";

// Dynamically determine the API base URL
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000"; // Default fallback for local dev

const axiosBackend = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Necessary for authentication (cookies, sessions)
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor (Optional)
// axiosInstance.interceptors.request.use(
//   (config) => {
//     // Example: Add auth token if needed
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Add a response interceptor (Optional)
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error("API Error:", error.response);
//     return Promise.reject(error);
//   }
// );

export default axiosBackend;
